module.exports = __webpack_public_path__ + "static/media/logo-new.a74cd9d3.png";